import { render, staticRenderFns } from "./GoalExampleContent.vue?vue&type=template&id=382f6981&scoped=true"
import script from "./GoalExampleContent.vue?vue&type=script&lang=js"
export * from "./GoalExampleContent.vue?vue&type=script&lang=js"
import style0 from "./GoalExampleContent.vue?vue&type=style&index=0&id=382f6981&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f6981",
  null
  
)

export default component.exports